import { Injectable, inject } from '@angular/core';
import {
  Order,
  OrdersCountMetadata,
  OrdersService,
  OrderUpdate,
} from '@compumark/order-management-client';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { OrderSelectionService } from '../selection/order-selection.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersApiClientService {
  private orderService = inject(OrdersService);
  private orderSelectionService = inject(OrderSelectionService);

  private currentStatus: 'active' | 'inactive' = 'active';

  getActiveTab(): string {
    return this.currentStatus;
  }

  public getOrders(orderStatus: 'active' | 'inactive'): Observable<Order[]> {
    this.currentStatus = orderStatus;
    return this.orderService.getOrders(this.currentStatus);
  }

  public cancelOrder(
    cancellationDate: number,
    orderId: string,
  ): Observable<any> {
    return this.orderService.patchOrder(
      { cancelDate: cancellationDate },
      this.currentStatus,
      orderId,
    );
  }

  public undoOrderCancellation(orderId: string): Observable<any> {
    return this.orderService.patchOrder(
      { cancelDate: null },
      this.currentStatus,
      orderId,
    );
  }

  public update(orderUpdate: OrderUpdate, orderId: string): Observable<any> {
    return this.orderService.patchOrder(
      orderUpdate,
      this.currentStatus,
      orderId,
      'response',
    );
  }

  public countOrders(
    orderStatus: 'active' | 'inactive',
  ): Observable<OrdersCountMetadata> {
    this.currentStatus = orderStatus;
    return this.orderService.countOrders().pipe(
      tap((ordersCountMetadata) => {
        this.orderSelectionService.update(
          ordersCountMetadata,
          this.currentStatus,
        );
      }),
    );
  }
  getOrdersByAlertId(watchAlertId: string): Observable<any[]> {
    return this.orderService.getOrdersByWatchAlertId(watchAlertId);
  }
}
